import { render } from "./System-Settings.vue?vue&type=template&id=2b09fd42&scoped=true"
import script from "./System-Settings.vue?vue&type=script&lang=js"
export * from "./System-Settings.vue?vue&type=script&lang=js"

import "./System-Settings.vue?vue&type=style&index=0&id=2b09fd42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b09fd42"]])

export default __exports__